import React from "react";
import { X, ListRestart } from "lucide-react";
import Button from "../ui/Button";
import KPIFilterForm from "./KPIFilterForm";

/**
 * Reusable filter sidebar for desktop and mobile
 */
export default function KPIFilterSidebar({
  isOpen,
  onClose,
  filters,
  onInputChange,
  onSubmit,
  onReset,
  loading,
  error,
  showInterval = true,
  showEndDate = false,
  showAggregation = true,
  isMobile = false,
  systems,
}) {
  if (!isOpen) return null;

  // Desktop version
  if (!isMobile) {
    return (
      <div className="hidden lg:block lg:w-80">
        <div className="bg-white rounded shadow-lg p-6 sticky top-20">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-[#191d23]">Filters</h2>
            <Button
              onClick={onReset}
              variant="outline"
              icon={<ListRestart size={22} strokeWidth={1.25} />}
            />
          </div>
          <KPIFilterForm
            filters={filters}
            onInputChange={onInputChange}
            onSubmit={onSubmit}
            loading={loading}
            error={error}
            showInterval={showInterval}
            showEndDate={showEndDate}
            showAggregation={showAggregation}
            systems={systems}
          />
        </div>
      </div>
    );
  }

  // Mobile version
  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
        onClick={onClose}
      />

      {/* Sidebar */}
      <div className="fixed inset-x-0 bottom-0 sm:inset-y-0 sm:right-0 sm:left-auto sm:w-96 bg-white z-50 lg:hidden animate-slide-up sm:animate-slide-in">
        <div className="flex flex-col h-full max-h-[90vh] sm:max-h-full">
          {/* Header */}
          <div className="flex justify-between items-center p-4 sm:p-6 border-b">
            <h2 className="text-lg sm:text-xl font-bold text-[#191d23]">
              Filters
            </h2>
            <div className="flex gap-2">
              <Button
                onClick={onReset}
                variant="outline"
                icon={<ListRestart size={20} strokeWidth={1.25} />}
              />
              <button
                onClick={onClose}
                className="p-2 hover:bg-gray-100 rounded"
                aria-label="Close filters"
              >
                <X size={24} />
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto p-4 sm:p-6">
            <KPIFilterForm
              filters={filters}
              onInputChange={onInputChange}
              onSubmit={(e) => {
                onSubmit(e);
                onClose(); // Close on mobile after submit
              }}
              loading={loading}
              error={error}
              showInterval={showInterval}
              showEndDate={showEndDate}
              showAggregation={showAggregation}
              systems={systems}
            />
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }

        @keyframes slide-in {
          from {
            transform: translateX(100%);
          }
          to {
            transform: translateX(0);
          }
        }

        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }

        .animate-slide-in {
          animation: slide-in 0.3s ease-out;
        }
      `}</style>
    </>
  );
}
